import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { AppIFrame } from "../components/AppIFrame";
import { CodeControlsMenu } from "../components/CodeControlsMenu";
import { ProjectEditor } from "../components/ProjectEditor";
import { EDITOR_VIEW_NAME } from "../core/constants";
import { store } from "../core/state";
import { getErrorCode, getStartCode } from "../features/coderunner";


export const DocumentationView = () => {
  const [editorState, ] = store.useState(EDITOR_VIEW_NAME);
  const [key, setKey] = useState('editor');

  const runApp = () => {
    setKey('app')
  }


  const executeCode = editorState?.data?.executionCode || getStartCode(editorState);
  const errorCode = getErrorCode(editorState);
  const timeStamp = editorState?.data?.time;

  const view = (
    <>
      <AppIFrame doc={errorCode || executeCode}
                 timeStamp={timeStamp}
                 classNames="ratio ratio-16x9"
                 fullScreen={false}
                 landscape={false}
                 muteSound={false}
                 hasAppBorder={true} />
    </>
  );

  const controlsCfg = {
    resetButtonEnabled : false
  }

  return (<div className="d-grid gap-2">
  <Tabs id="responsiveTabs" activeKey={key} onSelect={(k) => setKey(k)}>
    <Tab title="Editor" eventKey="editor" >
      <ProjectEditor />

    </Tab>
    <Tab title="App" eventKey="app" >
      {view}
    </Tab>
  </Tabs>
  <span><CodeControlsMenu runCode={runApp} cfg={controlsCfg} /></span>
</div>);
}
